import { Link } from 'react-router-dom';

const FOOTER_LINKS = [
  { label: '首页', to: '/' },
  { label: '电影', to: '/category/movie' },
  { label: '电视剧', to: '/category/tv' },
  { label: '热门影视', to: '/category/hot' },
];

const HELP_LINKS = [
  { label: '关于我们', to: '/about' },
  { label: '常见问题', to: '/help' },
  { label: '版权声明', to: '/about' },
  { label: '搜索影片', to: '/search' },
];

const CATEGORY_LINKS = [
  { label: '华语影视', to: '/category/movie/中国' },
  { label: '日韩影视', to: '/category/movie/韩国' },
  { label: '日本影视', to: '/category/movie/日本' },
  { label: '泰剧专区', to: '/category/tv/泰国' },
];

export default function Footer() {
  return (
    <footer className="bg-secondary-950 text-secondary-100 mt-16 pb-14 md:pb-0">
      <div className="w-full px-4 md:px-8 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 rounded-md bg-primary-500 text-background-950 flex items-center justify-center">
                <i className="ri-film-line"></i>
              </span>
              <span className="font-heading font-black text-base text-background-50">
                亚洲中文字幕在线观看
              </span>
            </div>
            <p className="text-sm leading-7 text-secondary-300">
              汇聚亚洲各国电影、电视剧等高清影视资源，全部配备中文字幕，让好作品跨越语言被更多观众看见。
            </p>
          </div>
          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 flex items-center gap-1">
              <a href="#footer-nav" className="cursor-pointer">快捷导航</a>
            </h4>
            <ul id="footer-nav" className="space-y-2">
              {FOOTER_LINKS.map((link) => (
                <li key={link.label}>
                  <Link to={link.to} className="text-sm text-secondary-300 hover:text-primary-400 cursor-pointer transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 flex items-center gap-1">
              <a href="#footer-category" className="cursor-pointer">热门分类</a>
            </h4>
            <ul id="footer-category" className="space-y-2">
              {CATEGORY_LINKS.map((link) => (
                <li key={link.label}>
                  <Link to={link.to} className="text-sm text-secondary-300 hover:text-primary-400 cursor-pointer transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 flex items-center gap-1">
              <a href="#footer-help" className="cursor-pointer">帮助与支持</a>
            </h4>
            <ul id="footer-help" className="space-y-2">
              {HELP_LINKS.map((link) => (
                <li key={link.label}>
                  <Link to={link.to} className="text-sm text-secondary-300 hover:text-primary-400 cursor-pointer transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
            <div className="mt-4 space-y-2 text-sm text-secondary-300">
              <p className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-400"></i>
                support@asia-subtitle.com
              </p>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-secondary-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-secondary-400">
            © 2026 亚洲中文字幕在线观看 · 本站为演示站点，所有影视资料均为虚构，仅供学习交流使用。
          </p>
          <div className="flex items-center gap-4 text-xs text-secondary-400">
            <Link to="/about" className="hover:text-primary-400 cursor-pointer">隐私政策</Link>
            <Link to="/about" className="hover:text-primary-400 cursor-pointer">免责声明</Link>
            <Link to="/help" className="hover:text-primary-400 cursor-pointer">联系我们</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}